import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: '#ECA72E',
      light: '#42a5f5',
      dark: '#1565c0',
      default: '#ECA72E33',
    },
    secondary: {
      main: '#234987',
      light: '#ff4081',
      dark: '#9a0036',
      default: '#3CE35B',
    },
    background: {
      default: '#f5f5f5',
      main: '#FAFAFA',
      light: '#C4C4C4',
      dark: '#7A8691',
      secondary: '#7A869126'
    },
    success: {
      main: '#10AE2D',
      light: '#DCFCE7'
    },
    text: {
      main: '#5D6776',
      light: '#16374A',
      dark: '#193CB8',
    },
    icon: {
      default: '#666',
      light: '#4A5565'
    },
    plan: {
      Free: '#EEF4FF',
      Gold: '#FFFCCF',
      Platinum: '#E0E0E0',
      Diamond: '#CAF4FF'
    },
    cardbackground: {
      primary: '#F0FDF4',
      secondary: '#EFF6FF',
      dark: '#0D542B',
      light: '#B9F8CF',
      middle: '#016630',
      main: '#BEDBFF'
    }
  },
  typography: {
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: '#1976d2',
            },
          },
        },
      },
    },
  },
});

export default theme;